import { render, staticRenderFns } from "./ProductModifiers.vue?vue&type=template&id=f3729252"
import script from "./ProductModifiers.vue?vue&type=script&lang=js"
export * from "./ProductModifiers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports